import(/* webpackMode: "eager" */ "/vercel/path0/src/app/card-view/page.tsx");
